<template>
	<div class="videsCss" style="padding:0 10px;background-color: black;">
		<video ref="videoElement" controls autoplay muted  width="100%" height="400px"></video>
		<!-- <div>
			{{vedios}}
		</div>
		<div>
			{{id}}
		</div>
		<div>
			{{title}}
		</div> -->
	</div>
</template>
<script>
	import mpegts from "mpegts.js";
	// import {useRouter} from 'vue-router'
	import flvjs from "flv.js";
	// const { currentRoute } = useRouter();
	// const route = currentRoute.value;
	export default {
		data() {
			return {
				// vedios: 'https://yfcxzx.cn:10002/videos/live?port=1936&app=live',ls.flv
				vedios: 'https://yfcxzx.cn:10002/srs/live/',
				id: null,
				flvPlayer: null,
				title: '监控视频'
			};
		},
		created() {
			this.id = this.$route.query.stream;
			this.vedios = this.vedios + this.id+'.flv';
			console.log(this.vedios);
		},
		mounted() {
			this.newShowVedio()
			// this.showVedio();
		},
		methods: {
			newShowVedio(){
				let _this = this;
				if (mpegts.getFeatureList().mseLivePlayback) {
				  var videoElement = this.$refs.videoElement;
				  if (typeof _this.flvPlayer !== "undefined") {
				    if (_this.flvPlayer != null) {
				      _this.flvPlayer.unload();
				      _this.flvPlayer.detachMediaElement();
				      _this.flvPlayer.destroy();
				      _this.flvPlayer = null;
				
				    }
				  }
				  var flvPlayer = mpegts.createPlayer({
				    type: 'flv',
				    isLive: true,
					url: this.vedios,
				    // url: 'https://yfcxzx.cn:10002/srs/live/ls.flv', //后端返回的视频流链接hasAudio:falsehasVideo: true,
				  }, {
				    isLive: true,
				    enableWorker: false,
				    LazyLoadMaxDuration: 3 * 60,
				    seekType: 'range',
				    // liveBufferLatencyChasing:true
				    withCredentials: true,
				    // 关闭I0隐藏缓冲区
				    enableStashBuffer: false,
				    //自动清除缓存
				    autoCleanupSourceBuffer: true,
				    responseType: "blob",
				    //是否开启自适应码率
				    enableAutoQuality: false,
				    // 检测到错误时是否自动重试
				    autoReloadOnError: true,
				    // 预加载的分片数量，单位为个，默认值为3个
				    segmentStartFetchNum: 3,
				  });
				  flvPlayer.attachMediaElement(videoElement);
				  flvPlayer.load();
				
				  flvPlayer.on(mpegts.Events.METADATA_ARRIVED, () => {
				    // console.log('视频加载完成1')
				    _this.flvPlayer.play();
				  })
				
				  //监听错误事件
				  flvPlayer.on(mpegts.Events.ERROR, (err, errdet) => {
				    // 参数 err 是一级异常，errdet 是二级异常
				    if (err == mpegts.ErrorTypes.MEDIA_ERROR) {
				      console.log('媒体错误')
				      if (errdet == mpegts.ErrorDetails.MEDIA_FORMAT_UNSUPPORTED) {
				        console.log('媒体格式不支持')
				        _this.mpegtsJs()
				      }
				    }
				    if (err == mpegts.ErrorTypes.NETWORK_ERROR) {
				      console.log('网络错误')
				      if (errdet = mpegts.ErrorDetails.NETWORK_STATUS_CODE_INVALID) {
				        console.log('http状态码异常')
				      }
				    }
				
				    if (err == mpegts.ErrorTypes.OTHER_ERROR) {
				      console.log('其他异常:', errdet)
				    }
				    _this.flvPlayer = flvPlayer
				  })
				}
			},
			showVedio(){
				this.$nextTick(() => {
					if (flvjs.isSupported()) {
						var videoElement = document.getElementById("videoElement");
						this.flvPlayer = flvjs.createPlayer({
							url:this.vedios,
							autostart:false,
							type: "flv",
							isLive: true,
							hasAudio: false,
							// url: "https://yfcxzx.cn:10002/videos/live?port=1936&app=live&stream=117",
						});
						this.flvPlayer.attachMediaElement(videoElement);
						this.flvPlayer.load();
						this.flvPlayer.play();
						// this.bofang();
					}
				})
			},
			bofang() {
				// setTimeout(function(){
				// 	console.log('播放---')
				// 	this.flvPlayer.load();
				// 	this.flvPlayer.play();
				// },5000)
			}
		}
	};
</script>

<style>
	.videsCss {
		background-color: #529FF9;
		/* padding:0 10px; */
		text-align: center;
		color: #ffffff;
	}
</style>